import { render, staticRenderFns } from "./ProductSwatchThumbnail.vue?vue&type=template&id=595eb213&scoped=true"
import script from "./ProductSwatchThumbnail.vue?vue&type=script&lang=ts"
export * from "./ProductSwatchThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./ProductSwatchThumbnail.vue?vue&type=style&index=0&id=595eb213&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595eb213",
  null
  
)

export default component.exports